import React from 'react';
import { useQuizz } from './quizz.hook';
import ListWithSubItems from '@/components/shared/ListWithSubItems';

const QuizzList = () => {
  const {
    quizzList,
    selectedQuizz,
    handleSelectedQuizz,
    quizzMenuItems,
    setSelectedQuizz,
  } = useQuizz();

  return (
    <ListWithSubItems
      items={quizzList || []}
      selectedItem={selectedQuizz}
      onItemSelect={(item) => {
        setSelectedQuizz(item);
        handleSelectedQuizz(item);
      }}
      menuItems={quizzMenuItems}
    />
  );
};

export default QuizzList;
